const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/workflows/history.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { workflowHistorySearchSchema } from "@/react/components/SettingsApp/Workflows/components/WorkflowHistoryTabs/workflowHistorySearchParamsSchema";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/workflows/history")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: workflowHistorySearchSchema
});